<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Url Metni"
      label-for="slug"
    >
      <b-form-input
        id="slug"
        v-model="itemData.translate.slug"
        placeholder="Url Metni"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.slug }}
        </div>
      </b-alert>
    </b-form-group>
    <!--    <b-form-group-->
    <!--      label="Özet Metin"-->
    <!--      label-for="summary"-->
    <!--    >-->
    <!--      <b-form-textarea-->
    <!--        id="summary"-->
    <!--        v-model="itemData.translate.summary"-->
    <!--        placeholder="Özet Metin"-->
    <!--      />-->
    <!--      <b-alert show>-->
    <!--        <div class="alert-body mt-1 font-small-2">-->
    <!--          <div v-html="itemData.item.summary" />-->
    <!--        </div>-->
    <!--      </b-alert>-->
    <!--    </b-form-group>-->
    <b-form-group
      label="İçerik"
      label-for="content"
    >
      <quill-editor
        id="content"
        v-model="itemData.translate.content"
        class="bg-white"
        :options="editorOption"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.content" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="İçerik Başlık"
      label-for="content_title"
    >
      <b-form-input
        id="content_title"
        v-model="itemData.translate.content_title"
        placeholder="İçerik Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.content_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="İçerik Alt Metin"
      label-for="content_sub_title"
    >
      <b-form-textarea
        id="content_sub_title"
        v-model="itemData.translate.content_sub_title"
        placeholder="İçerik Alt Metin"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.content_sub_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton, BFormTextarea,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'ProductCategories',
  components: {
    EditorToolbar,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
    quillEditor,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
